export default __webpack_public_path__ + "static/media/RatioUploadTemplate.2da62b5e.xlsx";